import { Link } from 'react-router-dom';

import './styles/Button.css';

export default function Button({ to, href, variant = 'primary', icon, children, className = '', ...rest }) {
    const classes = `button button--${variant} ${className}`.trim();
    const content = (
        <>
            <span className="button__label">{children}</span>
            {icon && <span className="button__icon">{icon}</span>}
        </>
    );

    if (to) return <Link to={to} className={classes} {...rest}>{content}</Link>;
    if (href) return <a href={href} className={classes} {...rest}>{content}</a>;
    return <button type="button" className={classes} {...rest}>{content}</button>;
}
